import VueRouter from "vue-router";
import { registerPendingWorkCheck } from "@/lib/services/pending-work-guard";

export function protectAllocationDraft(
  router: VueRouter | undefined,
  isDirty: () => boolean,
  isSaving: () => boolean,
  isAuthenticated: () => boolean = () => true
): () => void {
  const canLeave = () => {
    if (isSaving()) {
      return false;
    }
    return !isDirty() || window.confirm("Discard unsaved allocation changes?");
  };
  const removePendingCheck = registerPendingWorkCheck(canLeave);
  const removeGuard = router
    ? router.beforeEach((to, _from, next) => {
        if (to.path === "/account/login" && !isAuthenticated()) {
          next();
          return;
        }
        if (canLeave()) next();
        else next(false);
      })
    : () => undefined;
  const beforeUnload = (event: BeforeUnloadEvent) => {
    if (isDirty() || isSaving()) {
      event.preventDefault();
      event.returnValue = "";
    }
  };
  window.addEventListener("beforeunload", beforeUnload);
  return () => {
    removePendingCheck();
    removeGuard();
    window.removeEventListener("beforeunload", beforeUnload);
  };
}
